<script>
import RichmediaMixin from "./RichmediaMixin";

export default {
    props: {
        slug: null,
    },
    mixins:[RichmediaMixin],

    computed: {
        currentPage() {
            return this.$t('pages').getBySlug(this.slug);
        }
    }
}
</script>
